// Keep in sync with KeypadEventOut schema
export type KeypadEvent = {
  id: string;
  siteId: string;
  enteredAt: Date;
  enteredCode: string;
  status: "valid" | "invalid" | "expired" | "cleared";
  deviceName: string | null;
  imageUrl: string | null;
  createdAt: Date;
};

export const KeypadEventStatusOptions = [
  { label: "Valid", value: "valid" },
  { label: "Invalid", value: "invalid" },
  { label: "Expired", value: "expired" },
  { label: "Cleared", value: "cleared" },
] as const;

export const parseKeypadEvent = (
  apiResponse: RecursivelyConvertDatesToStrings<KeypadEvent>,
): KeypadEvent => ({
  ...apiResponse,
  enteredAt: new Date(apiResponse.enteredAt),
  createdAt: new Date(apiResponse.createdAt),
});
